interface Params {
  id: string;
  index: number;
  key: string;
  name: string;
}

export class SearchAreaGroup {
  readonly id: string;
  readonly index: number;
  readonly key: string;
  readonly name: string;

  constructor(params: Params) {
    this.id = params.id;
    this.index = params.index;
    this.key = params.key;
    this.name = params.name;
  }

  eq(other: SearchAreaGroup | null): boolean {
    if (other === null) {
      return false;
    }

    return this.key === other.key;
  }
}
